import axios, { AxiosPromise } from 'axios';

export const send = (email: {
  text: string;
  title: string;
  to: string;
}): AxiosPromise<any> => axios.post('/api/email-service', email);
